import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'wizard-breadcrumb',
  templateUrl: './wizard-breadcrumb.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class WizardBreadcrumbComponent {
  @Input() public breadcrumbs: string[] = []
  @Output('onClose') public close = new EventEmitter<void>()

  /**
   * @description Emit a close event. Uses mousedown (not click) so handler runs before input blur,
   * allowing cancelPendingBlurSave to run before blur-save is scheduled (same pattern as navbar logo).
   */
  public onClose(event?: MouseEvent): void {
    event?.preventDefault()
    event?.stopPropagation()
    this.close.emit()
  }
}
